export const categories = [
  { 
    id: 'sport',
    labels: {
      fr: 'Sport',
      en: 'Sports'
    },
    icon: '🏃‍♂️',
    subcategories: [
      { id: 'running', fr: 'Course à pied', en: 'Running' },
      { id: 'cycling', fr: 'Vélo', en: 'Cycling' },
      { id: 'gym', fr: 'Musculation', en: 'Gym' },
      { id: 'yoga', fr: 'Yoga', en: 'Yoga' },
      { id: 'swimming', fr: 'Natation', en: 'Swimming' },
      { id: 'team_sports', fr: 'Sports collectifs', en: 'Team Sports' }
    ]
  },
  { 
    id: 'outing',
    labels: {
      fr: 'Sortie',
      en: 'Outing'
    },
    icon: '🎉',
    subcategories: [
      { id: 'bar', fr: 'Bar', en: 'Bar' },
      { id: 'club', fr: 'Boîte de nuit', en: 'Nightclub' },
      { id: 'concert', fr: 'Concert', en: 'Concert' },
      { id: 'festival', fr: 'Festival', en: 'Festival' },
      { id: 'picnic', fr: 'Pique-nique', en: 'Picnic' }
    ]
  },
  { 
    id: 'cooking',
    labels: {
      fr: 'Cuisine',
      en: 'Cooking'
    },
    icon: '🍴',
    subcategories: [
      { id: 'baking', fr: 'Pâtisserie', en: 'Baking' },
      { id: 'grill', fr: 'Barbecue', en: 'Grill & BBQ' },
      { id: 'world_cuisine', fr: 'Cuisine du monde', en: 'World Cuisine' },
      { id: 'healthy', fr: 'Cuisine saine', en: 'Healthy Cooking' }
    ]
  },
  { 
    id: 'transport',
    labels: {
      fr: 'Transport',
      en: 'Transport'
    },
    icon: '🚗',
    subcategories: [
      { id: 'carpool', fr: 'Covoiturage', en: 'Carpooling' },
      { id: 'bike_sharing', fr: 'Partage de vélo', en: 'Bike Sharing' },
      { id: 'road_trip', fr: 'Road Trip', en: 'Road Trip' }
    ]
  },
  { 
    id: 'meeting',
    labels: {
      fr: 'Rencontre',
      en: 'Meeting'
    },
    icon: '☕',
    subcategories: [
      { id: 'coffee', fr: 'Café', en: 'Coffee Meetup' },
      { id: 'networking', fr: 'Réseautage', en: 'Networking' },
      { id: 'game_night', fr: 'Soirée jeux', en: 'Game Night' }
    ]
  },
  { 
    id: 'culture',
    labels: {
      fr: 'Culture',
      en: 'Culture'
    },
    icon: '📚',
    subcategories: [
      { id: 'museum', fr: 'Musée', en: 'Museum' },
      { id: 'theater', fr: 'Théâtre', en: 'Theater' },
      { id: 'book_club', fr: 'Club de lecture', en: 'Book Club' },
      { id: 'cinema', fr: 'Cinéma', en: 'Cinema' }
    ]
  },
  { 
    id: 'leisure',
    labels: {
      fr: 'Loisir',
      en: 'Leisure'
    },
    icon: '🎲',
    subcategories: [
      { id: 'board_games', fr: 'Jeux de société', en: 'Board Games' },
      { id: 'escape_room', fr: 'Escape Game', en: 'Escape Room' },
      { id: 'arcade', fr: 'Salle d’arcade', en: 'Arcade' }
    ]
  },
  { 
    id: 'kids',
    labels: {
      fr: 'Enfants',
      en: 'Kids'
    },
    icon: '🧒',
    subcategories: [
      { id: 'playground', fr: 'Aire de jeux', en: 'Playground' },
      { id: 'story_time', fr: 'Heure du conte', en: 'Story Time' },
      { id: 'crafts', fr: 'Ateliers créatifs', en: 'Creative Workshops' }
    ]
  },
  { 
    id: 'pets',
    labels: {
      fr: 'Animaux',
      en: 'Pets'
    },
    icon: '🐕',
    subcategories: [
      { id: 'dog_walk', fr: 'Balade canine', en: 'Dog Walk' },
      { id: 'pet_meetup', fr: 'Rencontre animaux', en: 'Pet Meetup' },
      { id: 'training', fr: 'Dressage', en: 'Training' }
    ]
  },
  { 
    id: 'other',
    labels: {
      fr: 'Autre',
      en: 'Other'
    },
    icon: '❓',
    subcategories: [
      { id: 'volunteering', fr: 'Bénévolat', en: 'Volunteering' },
      { id: 'custom', fr: 'Autre', en: 'Other' }
    ]
  }
];
